import { Typography } from "@mui/material";
import React, { useState } from "react";
import Chart from "react-apexcharts";
import { appLogger } from "../../utils";
import {
  enableBugReport,
  enableChatbot,
  enableFeatureRequest,
  enableFeedback,
  enableInsights,
} from "../../utils/config";
const DailyCountchart = (props: any) => {
  const {
    dailyCountBugChartData,
    dailyCountFeedbackChartData,
    dailyCountFeatureReqChartData,
  } = props;
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  // console.log(JSON.parse(userEnabledFeatures), "userEnabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  const charttcolrs = [];
  if (enableFeedback && userEnabledFeatures?.enableFeedback) {
    charttcolrs.push("#1fd351");
  }
  if (
    (enableBugReport && userEnabledFeatures?.enableBugReport) ||
    (enableChatbot && userEnabledFeatures?.enableChatbot)
  ) {
    charttcolrs.push("#fc6423");
  }
  if (enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest) {
    charttcolrs.push("#0157ff");
  }
  appLogger.info({
    infoObj: {
      method: "DailyCountchart",
      component: "dashboard",
      fileName: "DailyCountchart.tsx",
      props: props,
    },
  });
  type datetime = "datetime";
  const chartType: datetime = "datetime";
  const categoriesValue: number[] = dailyCountBugChartData
    ? Object.keys(dailyCountBugChartData.data).map((x) =>
        Number.parseInt(x, 10)
      )
    : dailyCountFeatureReqChartData
    ? Object.keys(dailyCountFeatureReqChartData.data).map((x) =>
        Number.parseInt(x, 10)
      )
    : Object.keys(dailyCountFeedbackChartData.data).map((x) =>
        Number.parseInt(x, 10)
      );
  const fdChartData: number[] = dailyCountFeedbackChartData
    ? Object.values(dailyCountFeedbackChartData.data)
    : [];
  const bugChartData: number[] = dailyCountBugChartData
    ? Object.values(dailyCountBugChartData.data)
    : [];
  const frChartData: number[] = dailyCountFeatureReqChartData
    ? Object.values(dailyCountFeatureReqChartData.data)
    : [];

  const series = [];
  const data = {
    options: {
      chart: {
        height: 350,
        stacked: false,
        toolbar: {
          export: {
            csv: {
              filename: "CuVo_Daily_Count",
            },
            svg: {
              filename: "CuVo_Daily_Count",
            },
            png: {
              filename: "CuVo_Daily_Count",
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "top" as "top" | "right" | "bottom" | "left" | undefined,
      },
      xaxis: {
        type: chartType,
        labels: {
          format: "MM/dd/yyyy",
        },
        categories: categoriesValue,
        tooltip: {
          enabled: false,
        },
      },
      colors: charttcolrs,
      fill: {
        colors: charttcolrs,
      },
      tooltip: {
        custom: function (config: any) {
          return (
            `<div class="custom-tooltip" style="background: ${
              config.w.config.fill.colors[config.seriesIndex]
            }">` +
            "<h2 class='tooltip-title'>daily count :<span>" +
            config.w.globals.initialConfig.series[config.seriesIndex].name +
            "</span>" +
            "</h2>" +
            "<div class='tooltip-info'>" +
            config.series[config.seriesIndex][config.dataPointIndex] +
            "<span>" +
            `(${
              config.series[config.seriesIndex][config.dataPointIndex] > 0
                ? Math.floor(
                    (config.series[config.seriesIndex][config.dataPointIndex] /
                      config.w.globals.yRange[0]) *
                      100
                  )
                : 0
            }%)` +
            "</span></div>" +
            "</div>"
          );
        },
        x: {
          format: "MM/dd/yyyy",
        },
      },

      events: {
        click: function (event: any, chartContext: any, config: any) {
          appLogger.info({
            infoObj: {
              method: "DailyCountchart",
              component: "dashboard",
              fileName: "DailyCountchart.tsx",
              data: { event, chartContext, config },
            },
          });
          // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
        },
      },
      grid: {
        show: false,
      },
      stroke: {
        show: true,
        // curve: "smooth",
        // lineCap: "butt",
        colors: undefined,
        width: 1,
        dashArray: 0,
      },
    },
  };

  if (enableFeedback && userEnabledFeatures?.enableFeedback) {
    fdChartData.length > 0
      ? series.push({
          name: "Feedback",
          data: fdChartData,
        })
      : "";
  }

  if (
    (enableBugReport && userEnabledFeatures?.enableBugReport) ||
    (enableChatbot && userEnabledFeatures?.enableChatbot)
  ) {
    bugChartData.length > 0
      ? series.push({
          name: "Bugs",
          data: bugChartData,
        })
      : "";
  }
  if (enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest) {
    frChartData.length > 0
      ? series.push({
          name: "Feature Request",
          data: frChartData,
        })
      : "";
  }

  return (
    <>
      {dailyCountBugChartData.total > 0 ||
      dailyCountFeedbackChartData.total > 0 ||
      dailyCountFeatureReqChartData.total > 0 ? (
        <Chart options={data.options} series={series} type="bar" height={280} />
      ) : (
        ""
      )}

      {dailyCountBugChartData.total == 0 &&
        dailyCountFeedbackChartData.total == 0 &&
        dailyCountFeatureReqChartData.total == 0 && (
          <Typography className="no-data">no data</Typography>
        )}
    </>
  );
};

export default DailyCountchart;
